<div class="px-4 h-[calc(100vh-90px)] grid grid-rows-[auto_1fr]">

  @if(invalidRange) {
  <div class="text-center py-20 bg-gray-50 rounded-xl border border-dashed border-gray-300 mt-6">
    <p class="text-gray-500">No time slot to log — pick one on the timeline first.</p>
    <button (click)="goToActivity()"
      class="mt-4 inline-flex items-center gap-2 px-4 py-2 bg-blue-600 text-white text-sm font-semibold rounded-lg hover:bg-blue-700 transition-colors cursor-pointer">
      Back to activity
    </button>
  </div>
  }

  @else if(startTime && endTime) {
  <!-- Breadcrumb -->
  <div class="flex items-center gap-1.5 mt-5 mb-4 flex-wrap">
    <button (click)="goToActivity()"
      class="inline-flex items-center gap-1 text-sm text-gray-400 hover:text-gray-700 transition-colors cursor-pointer group">
      <svg class="w-4 h-4 group-hover:-translate-x-0.5 transition-transform" fill="none" stroke="currentColor"
        viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
      </svg>
      Activity
    </button>
    <span class="text-gray-300">›</span>
    <span class="text-sm font-medium text-gray-700">New time entry</span>
    <span class="text-xs text-gray-400">
      {{ startTime | date:'dd/MM/yyyy HH:mm' }} → {{ endTime | date:'HH:mm' }}
    </span>
  </div>

  <app-entry-modal class="min-h-0 pb-4" presentation="page" [startTime]="startTime" [endTime]="endTime"
    (save)="onSave($event)" (cancel)="goToActivity()">
  </app-entry-modal>
  }
</div>
